import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../Shared/Redux/store';

const initialState = {
  editBillingData: null,
  isAddPaymentModalOpen: false,
  isBillItemModalOpen: false,
  isAssignModalOpen: false,
  billingMetaData: null,
  chargesMetaData: null,
  isCopyModalOpen: false,
  isSelectClassModalOpen: false,
};

const PaymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setIsAddPaymentModalOpen: state => {
      state.isAddPaymentModalOpen = !state.isAddPaymentModalOpen;
    },
    setIsSelectClassModalOpen: state => {
      state.isSelectClassModalOpen = !state.isSelectClassModalOpen;
    },

    setIsBillItemModalOpen: state => {
      state.isBillItemModalOpen = !state.isBillItemModalOpen;
    },
    setBillingMetaData: (state, action: PayloadAction<any>) => {
      state.billingMetaData = action.payload;
    },

    setEditBillingData: (state, action: PayloadAction<any>) => {
      state.editBillingData = action.payload;
    },

    setChargesMetaData: (state, action: PayloadAction<any>) => {
      state.chargesMetaData = action.payload;
    },
    setIsCopyModalOpen: state => {
      state.isCopyModalOpen = !state.isCopyModalOpen;
    },
  },
});

export const selectisAddPaymentModalOpen = (state: RootState) =>
  state.payment.isAddPaymentModalOpen;

export const selectBillingMetaData = (state: RootState) =>
  state.payment.billingMetaData;

export const selectEditBillingData = (state: RootState) =>
  state.payment.editBillingData;

export const selectChargesMetaData = (state: RootState) =>
  state.payment.chargesMetaData;

export const selectIsBillItemModalOpen = (state: RootState) =>
  state.payment.isBillItemModalOpen;

export const selectIsCopyModalOpen = (state: RootState) =>
  state.payment.isCopyModalOpen;

export const selectClassModal = (state: RootState) =>
  state.payment.isSelectClassModalOpen;

export const {
  setIsAddPaymentModalOpen,
  setBillingMetaData,
  setChargesMetaData,
  setEditBillingData,
  setIsBillItemModalOpen,
  setIsCopyModalOpen,
  setIsSelectClassModalOpen,
} = PaymentSlice.actions;
export default PaymentSlice.reducer;
